<script>
  import Dispatch from '../Dispatcher'
  import { fade, fly } from 'svelte/transition';
	let menu = Dispatch.getState('menu')
  export let name
</script>

{#if $menu.open}
<!-- Absolute positioning requires a relative parent -->
<div class='w-100 relative'>
  <div class='absolute w-100 flex justify-center white' style='top: 65px; z-index: 10000' in:fade="{{ duration: 400 }}" out:fade="{{ duration: 500 }}">
    <div class='w-100 ph1 flex justify-between'>
      <div></div>
        <div class='pl5 pv4 bg-black bb br bl b--white fw4 f5' style="border-bottom-left-radius:15px; border-bottom-right-radius:15px;  " >

            <!-- <div class='w-100 ph3 flex justify-between'>
              <div></div>
              <div class='relative fw8 pointer' on:click={e => Dispatch.nextState('menu.open', false)}>X</div>
            </div> -->

            <div class='ph4 flex justify-between pointer'>
              <div></div>
              <a href='https://www.easttroylights.com/' class='link white'><div>East Troy Lights</div> </a>
            </div>
            <div class='pt3 ph4 flex justify-between pointer'>
              <div></div>
              <a href='https://easttroy.org/events/2022/may/27/east-troys-45th-annual-corn-brat-roast/' class='link white'><div>East Troy Brewfest</div> </a>
            </div>
            <div class='pt3 ph4 flex justify-between pointer'>
              <div></div>
              <a href='https://easttroy.org/contact/' class='link white'><div>Contact</div> </a>
            </div>
            <div class='pt3 ph4 flex justify-between pointer'>
              <div></div>
              <a href='https://easttroy.org/chamber/' class='link white'><div>About</div> </a>
            </div>
            <!-- <div class='w-100 pt3 flex justify-center'>
              <div class='w-100 bt b--gray'></div>
            </div> -->

        

        </div>
    </div>
  </div>
</div>
{/if}

<style>
</style>